module.exports = __webpack_public_path__ + "img/10-01.59bd9539.svg";